<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="wrapper-page header-fix-1 position-relative ">
    <div class="row justify-content-center ">
      <div class="img-wrapper position-relative">
        <!-- <img src="/assets/images/background-img.svg" alt="Snow" class="w-100" /> -->
      </div>
      <div class="position-absolute">
        <h2 class="mt-5 text-white font-size-25 font-weight-500">SEARCH APPOINTMENT</h2>
        <p class="font-size-18 text-white mt-3 text-center">View application status, attend consulation, Rescedule or
          cancel
          appointments
        </p>
        <div class="input-group w-75 mx-auto mt-5">
          <input type="text" class="form-control" placeholder="Enter Appointment ID" on-focusout="gotoPage()" id="aptid"
            [(ngModel)]="aptid" />
          <div class="input-group-append">
            <button type="submit" class="btn h-100 bg-white" [disabled]="!aptid" (click)="gotoPage()">
              <i class="fa fa-search"></i></button>
          </div>
        </div>

        <div class="mt-5 text-center">
          <img src="/assets/images/image 2.svg" />
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>